import { defaultHttpClient } from '../../httpClient';
import type {
  PostValidatePasswordAuthRequest,
  PostValidatePasswordAuthResponse,
} from './types';

/**
 * 비밀번호 찾기 — 인증번호를 검증.
 */
export const postValidatePasswordAuth = (
  params: PostValidatePasswordAuthRequest,
) => {
  return defaultHttpClient
    .request<PostValidatePasswordAuthResponse>({
      method: 'POST',
      url: '/api/v2/members/validate_password_auth/',
      data: params,
    })
    .then(result => result.data);
};
